import ImageGallerySelector from "../pages/image-gallery-selector";

const ImageGalleryApp = (props) => <ImageGallerySelector {...props} />;

export default ImageGalleryApp;
